import { Component, Input } from '@angular/core';

// Фаза 4: shared loading placeholder for all 7 Analytics screens. KPI-tile-shaped and
// chart-shaped grey blocks with Tailwind's own animate-pulse - no new colors/fonts, just
// bg-surface-gray on bg-surface/border-line, already in the SETTE palette (tailwind.config.js).
// Shown only on a screen's FIRST load (no data yet, see each screen's showSkeleton getter) - a
// filter-change refetch keeps the real content on screen, faded via that screen's own
// [class.opacity-50]="loading", never swapped back to this.
@Component({
	selector: 'app-analytics-skeleton',
	standalone: true,
	templateUrl: './analytics-skeleton.component.html',
})
export class AnalyticsSkeletonComponent {
	@Input() kpiCount = 4;
	@Input() chartCount = 2;

	get kpis(): number[] {
		return Array.from({ length: this.kpiCount });
	}

	get charts(): number[] {
		return Array.from({ length: this.chartCount });
	}
}
